import { Faq } from 'models';

/**
 * FAQ Module Utils
 */
export class FaqUtils {
  /**
   * Generates the schema.org structured data for the FAQ Module
   * @param faqs
   * @returns {string | null} Returns the corresponding schema.org as string
   */
  public static generateSchema(faqs: Faq[]): string | null {
    let schemaJson;
    const faqsForJson = [];

    if (!faqs || !faqs.length) {
      return null;
    }

    for (const faq of faqs) {
      if (faq.answer) {
        const textValue = faq.answer.replace('"', '\\"');
        faqsForJson.push({
          name: faq.question,
          '@type': 'Question',
          acceptedAnswer: {
            '@type': 'Answer',
            text: textValue
          }
        });
      }
    }

    schemaJson = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqsForJson
    };

    return JSON.stringify(schemaJson);
  }
}
